import { BaseUrlParamsFilter, BaseUrlParamsFilterProps } from 'entities/filters/base-url-params-filter';
import { Field } from 'formik';
import { TaskStatusPickerField } from 'shared/ui/formik-fields/task-status-picker-field';

export const TaskStatusParamFilter = ({ queryParamName, label = 'Статус', size = 'small' }: BaseUrlParamsFilterProps) => {
  return (
    <BaseUrlParamsFilter queryParamName={queryParamName}>
      <Field
        name={queryParamName}
        component={TaskStatusPickerField}
        multi={true}
        fullWidth
        label={label}
        clearable={true}
        size={size}
        customSize={1}
        compactTags={true}
      />
    </BaseUrlParamsFilter>
  );
};
